<span *ngIf="!hideLabel" class="text-lg text-800 font-medium p-3">Kommentare</span>
<div class="p-3">
    <div
            *ngIf="!focused"
            class="formgroup-inline align-items-center">
        <input placeholder="Kommentar eingeben"
               class="w-full"
               (focusin)="focused = true"
               type="text"
               pInputText />
    </div>
    <div
            *ngIf="focused"
            class="formgroup-inline align-items-center rounded-normal"
            [class.custom-field-disabled]="busy">
        <div class="col-12">

            <mvs-quill-editor
                    [content]="content"
                    [isEndUserTicket]="euVisible"
                    [documentTypeId]="documentTypeId"
                    [objectIdentifier]="objectIdentifier"
                    [mentionUsers]="mentionUsers"
                    (onSave)="createComment($event)"
                    (onContentChange)="handleInputChange($event)"
                    (onUploadDocument)="handleDocumentUpload($event)">
            </mvs-quill-editor>
        </div>
    </div>
</div>
